export const heroSlides = [
  {
    id: 'slide-01',
    workId: 'movie-01',
    title: '铃芽之旅',
    originalTitle: 'すずめの戸締まり',
    kicker: '本周焦点 · 中文字幕已更新',
    tagline: '跨越列岛的奇幻旅程，用勇气关闭灾难之门。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20atmospheric%20cinematic%20background%20of%20a%20ruined%20doorway%20standing%20in%20vast%20grassland%20under%20a%20towering%20glowing%20sky%2C%20deep%20teal%20and%20warm%20amber%20gradient%2C%20volumetric%20mist%20and%20light%20rays%2C%20no%20text%2C%20abstract%20artistic%20film%20aesthetic%2C%20wide%20dramatic%20composition%2C%20soft%20film%20grain&width=1600&height=900&seq=hero-slide-01&orientation=landscape',
  },
  {
    id: 'slide-02',
    workId: 'movie-06',
    title: '分手的决心',
    originalTitle: '헤어질 결심',
    kicker: '热门推荐 · 简繁双语字幕',
    tagline: '海雾之下的理性与情感，在克制中逐渐失控。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20moody%20cinematic%20background%20of%20a%20misty%20dark%20ocean%20with%20a%20lone%20silhouette%20on%20a%20rocky%20cliff%2C%20deep%20ocean%20blue%20and%20soft%20copper%20gradient%2C%20rolling%20fog%20and%20diffused%20light%2C%20no%20text%2C%20abstract%20artistic%20film%20aesthetic%2C%20wide%20dramatic%20composition%2C%20soft%20film%20grain&width=1600&height=900&seq=hero-slide-02&orientation=landscape',
  },
  {
    id: 'slide-03',
    workId: 'tv-01',
    title: '重启人生',
    originalTitle: 'ブラッシュアップライフ',
    kicker: '口碑新番 · 全集中文字幕完成',
    tagline: '一次次重启的日常，为了下辈子投个好人。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20dreamy%20cinematic%20background%20of%20a%20quiet%20Japanese%20suburban%20street%20at%20golden%20hour%20with%20floating%20clock%20and%20cloud%20motifs%2C%20soft%20mint%20green%20and%20warm%20amber%20gradient%2C%20gentle%20sunlight%20and%20light%20particles%2C%20no%20text%2C%20abstract%20artistic%20film%20aesthetic%2C%20wide%20dramatic%20composition%2C%20soft%20film%20grain&width=1600&height=900&seq=hero-slide-03&orientation=landscape',
  },
  {
    id: 'slide-04',
    workId: 'variety-03',
    title: '街舞女战士 第2季',
    originalTitle: '스트리트 우먼 파이터2',
    kicker: '综艺热播 · 舞台字幕精校',
    tagline: '顶级女子舞团同台，用编舞点燃舞台。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20high%20energy%20cinematic%20background%20of%20a%20dark%20dance%20stage%20with%20dramatic%20spotlights%20and%20abstract%20dancer%20silhouettes%2C%20vivid%20magenta%20amber%20and%20deep%20indigo%20gradient%2C%20haze%20and%20light%20beams%2C%20no%20text%2C%20artistic%20performance%20film%20aesthetic%2C%20wide%20dramatic%20composition%2C%20soft%20film%20grain&width=1600&height=900&seq=hero-slide-04&orientation=landscape',
  },
];

export const categoryEntries = [
  {
    type: 'movie',
    title: '电影',
    subtitle: 'Movie',
    description: '日本、韩国院线电影与独立佳作的公映及蓝光版中文字幕。',
    icon: 'ri-film-line',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20minimal%20cinematic%20illustration%20of%20a%20vintage%20film%20reel%20and%20empty%20cinema%20seats%20in%20warm%20spotlight%2C%20deep%20indigo%20and%20amber%20gradient%2C%20abstract%20geometric%20composition%2C%20no%20text%2C%20elegant%20editorial%20poster%20aesthetic%2C%20soft%20grain&width=800&height=600&seq=cat-entry-movie&orientation=landscape',
  },
  {
    type: 'tv',
    title: '电视剧',
    subtitle: 'TV Series',
    description: '日韩剧集整季字幕追踪，更新进度与制作状态一目了然。',
    icon: 'ri-tv-2-line',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20minimal%20cinematic%20illustration%20of%20a%20retro%20television%20set%20with%20glowing%20screen%20lines%2C%20deep%20teal%20and%20warm%20amber%20gradient%2C%20abstract%20geometric%20composition%2C%20no%20text%2C%20elegant%20editorial%20poster%20aesthetic%2C%20soft%20grain&width=800&height=600&seq=cat-entry-tv&orientation=landscape',
  },
  {
    type: 'variety',
    title: '综艺',
    subtitle: 'Variety',
    description: '人气日韩综艺节目字幕合集，含规则与流行语注释。',
    icon: 'ri-mic-line',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20minimal%20cinematic%20illustration%20of%20a%20stage%20microphone%20with%20confetti%20and%20spotlights%2C%20vivid%20coral%20orange%20and%20deep%20indigo%20gradient%2C%20abstract%20geometric%20composition%2C%20no%20text%2C%20elegant%20editorial%20poster%20aesthetic%2C%20soft%20grain&width=800&height=600&seq=cat-entry-variety&orientation=landscape',
  },
];

export const siteStats = [
  { label: '收录作品', value: '3,200+', icon: 'ri-stack-line' },
  { label: '字幕版本', value: '9,800+', icon: 'ri-file-text-line' },
  { label: '合作字幕组', value: '46', icon: 'ri-team-line' },
  { label: '每日更新', value: '60+', icon: 'ri-refresh-line' },
];